import { render, staticRenderFns } from "./ChoiceImage.vue?vue&type=template&id=95606594&scoped=true&"
import script from "./ChoiceImage.vue?vue&type=script&lang=js&"
export * from "./ChoiceImage.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceImage.vue?vue&type=style&index=0&id=95606594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95606594",
  null
  
)

export default component.exports